import { Avatar } from '@mui/material';

/** Deterministic initials mark so the same person always looks the same. */
export function Initials({ name, size = 36 }: { name: string; size?: number }) {
  const parts = name.trim().split(/\s+/);
  const text = ((parts[0]?.[0] ?? '') + (parts.length > 1 ? parts[parts.length - 1]?.[0] ?? '' : '')).toUpperCase() || '?';
  return (
    <Avatar sx={{ width: size, height: size, fontSize: size * 0.36, fontWeight: 600, letterSpacing: '0.02em', bgcolor: 'action.selected', color: 'text.primary', border: 1, borderColor: 'divider' }}>{text}</Avatar>
  );
}
